module.exports = __webpack_public_path__ + "img/logo_1@3x.74cadcec.png";